import { list } from './list';
export {
  type SchemaFieldListQuery,
  type SchemaFieldListResponse,
} from './list';

export const schemaFields = {
  list,
};
